import { render, staticRenderFns } from "./ChildEmergencyContact.vue?vue&type=template&id=2b0c63ac&"
import script from "./ChildEmergencyContact.vue?vue&type=script&lang=js&"
export * from "./ChildEmergencyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports